//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.Teaching.js";
let d=[[],[[[],"GetInputTypeName",{R_:{name:''}},0,0],[["name"],"SetInputTypeName",{},1,0],[[],"GetOutputTypeName",{R_:{name:''}},0,0],[["name"],"SetOutputTypeName",{},1,0],[[],"GetFeature",{R_:{feature:"CAM.CAMFeature"}},0,0],[["feature"],"SetFeature",{},1,0],[["name"],"AddNewMappingRule",{},1,0],[[],"Teach",{},0,0]],[]];
SPLM.CAM.MapFeatureTeaching = class extends SPLM.CAM.Teaching{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MapFeatureTeaching";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;